const doc = [({"da":({"js":({"layout":({"require_two_factor_authentication_proxy":({"please_set_up_two_factor_authentication":"Sæt venligst two-faktor godkendelse op."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;